import {
    AdditionalRating,
    VodItemDetails,
    Offer,
} from '../../../types/vod/VodItemDetails'

class VodDetails {
    actionButtons?: number
    additionalRating?: AdditionalRating
    atmosphericUrl?: string
    aspectRatio?: string
    cast?: string[]
    channelName?: string
    country?: string
    coverUrl?: string
    crew?: string
    description?: string
    duration?: number | null | undefined
    entitlementEndInfo?: string
    genres?: string[]
    isPurchased?: number
    isFavorite?: boolean
    pcLevel?: number
    price?: string
    priceLabel?: string
    productId?: string
    productType?: string
    requiredPackets?: Array<{ id: string; name: string; sort: string }>
    shortDescription?: string
    timeOfEvent?: string
    title?: string
    trailerProductId?: string
    trailerProductType?: string
    year?: number
    offers?: Offer[]

    constructor(vodItemDetailsProps: VodItemDetails) {
        this.actionButtons = vodItemDetailsProps.actionButtons
        this.additionalRating = vodItemDetailsProps.additionalRating
        this.aspectRatio = vodItemDetailsProps.aspectRatio
        this.atmosphericUrl = vodItemDetailsProps.atmosphericUrl
        this.cast = vodItemDetailsProps.cast
        this.channelName = vodItemDetailsProps.channelName
        this.country = vodItemDetailsProps.country
        this.coverUrl = vodItemDetailsProps.coverUrl
        this.crew = vodItemDetailsProps.crew
        this.description = vodItemDetailsProps.description
        this.duration = vodItemDetailsProps.duration
        this.entitlementEndInfo = vodItemDetailsProps.entitlementEndInfo
        this.genres = vodItemDetailsProps.genres
        this.isPurchased = vodItemDetailsProps.isPurchased
        this.isFavorite = vodItemDetailsProps.isFavorite
        this.pcLevel = vodItemDetailsProps.pcLevel
        this.price = vodItemDetailsProps.price
        this.priceLabel = vodItemDetailsProps.priceLabel
        this.productId = vodItemDetailsProps.productId
        this.productType = vodItemDetailsProps.productType
        this.requiredPackets = vodItemDetailsProps.requiredPackets
        this.shortDescription = vodItemDetailsProps.shortDescription
        this.timeOfEvent = vodItemDetailsProps.timeOfEvent
        this.title = vodItemDetailsProps.title
        this.trailerProductId = vodItemDetailsProps.trailerProductId
        this.trailerProductType = vodItemDetailsProps.trailerProductType
        this.year = vodItemDetailsProps.year
        this.offers = vodItemDetailsProps.offers
    }
}

export default VodDetails
